<template>
	<div class="content_main">
		<div class="left">
			<search-tree :treeData="deptTree" :dataList="dataList" :expandedKeys="expandedKeys" :holderText="holderText" @select="handleSelect">
			</search-tree>
		</div>
		<div class="right">
			<div class="content_main_top">
				<a-input placeholder="请输入用户名" class="a_input_self margin_self" v-model="queryParam.userName" @keyup.enter.native="$refs.table.refresh(true)" />
				<a-input placeholder="请输入登录名" class="a_input_self margin_self" v-model="queryParam.loginName" @keyup.enter.native="$refs.table.refresh(true)" />
				<a-select placeholder="请选择状态" class="a_input_self margin_self" v-model="queryParam.status" @keyup.enter.native="$refs.table.refresh(true)">
					<a-select-option :value="''">全部</a-select-option>
					<a-select-option :value="'0'">正常</a-select-option>
					<a-select-option :value="'1'">停用</a-select-option>
				</a-select>
				<a-input placeholder="请输入创建人" class="a_input_self margin_self" v-model="queryParam.createBy" @keyup.enter.native="$refs.table.refresh(true)" />
				<a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
				<a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
				<a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
				<a-button type="primary" v-if="allresetEnable" @click="resetAll">重置密码</a-button>
			</div>
			<div class="content_main_center_scroll" id="content_main_center_scroll">
				<s-table size="default" ref="table" rowKey="userId" :columns="columns" :data="loadData" :scroll="{ y: scroll_y }" 
				 defaultSort="createTime">
					<span slot="status" slot-scope="text, record">
						<a-switch :disabled="!editEnabel" :checked="record.status == '0'" @change="onChangeStatus(record)" />
					</span>
					<span slot="action" slot-scope="text, record">
						<a v-if="goodsManage" @click="itemManagement(record)">物品管理</a>
						<a-divider v-if="goodsManage && (editEnabel || resetPwdEnable || allresetEnable|| (unboundEnable && record.wxCode))" type="vertical" />
						<a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
						<a-divider v-if="editEnabel && ( resetPwdEnable || allresetEnable|| (unboundEnable && record.wxCode))" type="vertical" />
						<a v-if="resetPwdEnable" @click="resetPwd(record)">修改密码</a>
						<a-divider type="vertical" v-if="resetPwdEnable && ((unboundEnable && record.wxCode) ||allresetEnable)" />
						<a v-if="unboundEnable && record.wxCode" @click="wechat(record)">解绑微信</a>
						<a-divider v-if="(unboundEnable && record.wxCode) && allresetEnable" type="vertical" />
						<a v-if="allresetEnable" @click="changePwd(record)">重置密码</a>
					</span>
				</s-table>
			</div>
		</div>
		<user-modal ref="modal" @ok="handleOk" :deptTree="deptTree" />
		<user-pwd-modal ref="pwdmodal" />
		
		 <a-modal class="gufiiguy" title="离职物品管理" :visible="itemsVisible" @cancel="itemsVisible = false" width="70%">
			 <Quit :rowData="rowData" @put="$refs.table.refresh(true)"></Quit>
         </a-modal>
	</div>
</template>

<script>
import Quit from './Quit/index.vue'
	import {
		STable,
		SearchTree
	} from '@/components'
	import {
		getUserList,
		getDeptListEnable,
		delUser,
		changUserStatus,
		resetPwd_dept,
		resetPwd_user
	} from '@/api/system'
	import {
		update_wx
	} from '@/api/assetmenag'
	import UserModal from './modules/UserModal'
	import UserPwdModal from './modules/UserPwdModal'
	import pick from 'lodash.pick'
	import { dutyAsset_list} from '@/api/Industry'
	import {
		checkPermission
	} from '@/utils/permissions'
	export default {
		name: 'UserList',
		components: {
			SearchTree,
			STable,
			UserModal,
			UserPwdModal,
			Quit
		},
		data() {
			return {
				itemsVisible: false,
				// hackReset: true,
				description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
				visible: false,
				labelCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 5,
					},
				},
				wrapperCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 16,
					},
				},
				mdl: {},
				// 高级搜索 展开/关闭
				advanced: false,
				// 查询参数
				queryParam: {},
				// 表头
				columns: [{
						title: '登录名',
						dataIndex: 'loginName',
					},
					{
						title: '用户名',
						width: '100px',
						dataIndex: 'userName',
					},
					{
						title: '邮箱',
						dataIndex: 'email',
					},
					{
						title: '状态',
						dataIndex: 'status',
						scopedSlots: {
							customRender: 'status',
						},
					},
					{
						title: '创建人',
						dataIndex: 'createBy',
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						sorter: true,
					},
					{
						title: '更新人',
						dataIndex: 'updateBy',
					},
					{
						title: '更新时间',
						dataIndex: 'updateTime',
						sorter: true,
					},

					{
						title: '操作',
						width: '240px',
						dataIndex: 'action',
						scopedSlots: {
							customRender: 'action',
						},
					},
				],
				// 加载数据方法 必须为 Promise 对象
				loadData: (parameter) => {
					console.log('getloadDataPP');
					return getUserList(Object.assign(parameter, this.queryParam))
				},
				deptTree: [],
				expandedKeys: [],
				dataList: [],
				holderText: '搜索部门',
				selectedRowKeys: [],
				selectedRows: [],
				resettitle: '',
				addEnable: checkPermission('system:user:add'), //新建
				editEnabel: checkPermission('system:user:edit'), //编辑
				goodsManage: checkPermission('system:user:good'),// 物品管理
				resetPwdEnable: checkPermission('system:user:resetPwd'), //修改密码
				removeEnable: checkPermission('system:user:remove'), // 删除
				exportEnable: checkPermission('system:user:export'), // 导出
				importEnable: checkPermission('system:user:import'), //导入
				unboundEnable: checkPermission('system:user:unbound'), //解绑微信
				allresetEnable: checkPermission('system:user:allreset'), //手动重置密码
				rowData: ''

			}
		},
		created() {
			getDeptListEnable().then((res) => {
				const data = res.rows
				if (data.length > 0) {
					const min = Math.min(...data.map((m) => m.parentId))
					this.buildtree(data, this.deptTree, min)
					console.log(this.deptTree, 'sss')
					this.expandedKeys = data.map((m) => m.parentId)
					this.dataList = data.map((m) => {
						return {
							key: m.deptId,
							title: m.deptName,
						}
					})
				}
			})
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				this.scroll_y = max_h - 110
			})
		},

		methods: {
			// refresh() {
            //        //刷新子组件 ，top-bar是vue组件实例的名字 ,tabs时引用的名字,refreshs是Vue自带的方法
            //      },
			// refreshStatus(data) {
			// 	console.log(data, 'data================================')
			// 	console.log('9999999999999999999999999999999999999999999999')
			// 	console.log(this.$refs.table, 'this.$refs.table=============================')
			// 	// this.refresh()
			// 	// this.$refs.table.refresh()
			// 		this.$nextTick(() => {
			// 			// this.$refs.table.refresh()
			// 	})
				
			// },
			//物品管理事件
			itemManagement(row) {
				if (row.status == 0) {
					this.$router.push({
					path: '/system/UserList/quit?id=' + row.userId ,
				// 	// params: {
				// 	// 	id: row.
					// }
				// 	// query: {
				// 	// 	row: row
				// 	// }
				})
				} else {
					this.$message.warning('离职人员不可修改物品信息！')
				}
				
				// console.log(row, 'row==========================')
				// this.rowData = row 
				// console.log(this.rowData, 'rowData2222222222222==========================')
				// // this.itemsVisible = true
				// this.$router.push('')

			},
			changePwd(row) {
				var that = this
				this.$confirm({
					title: '是否重置 ' + row.userName + ' 的密码?',
					onOk() {
						resetPwd_user(row).then(res => {
							if (res.code == 200) {
								that.$message.success(res.msg)
							} else {
								that.$message.error(res.msg)
							}
						})
					},
					onCancel() {
						that.$message.warning('你取消了操作')
					},
				})
			},
			resetAll() {
				this.dataList.forEach(item => {
					if (item.key == this.queryParam.deptId) {
						this.resettitle = item.title
					}
				})
				if (this.queryParam.deptId == undefined) {
					this.$message.error('请从左侧列表选择部门！')
				} else {
					var that = this
					this.$confirm({
						title: '是否重置 ' + this.resettitle + ' 所有用户的密码?',
						onOk() {
							resetPwd_dept(that.queryParam.deptId).then(res => {
								if (res.code == 200) {
									that.$message.success(res.msg)
								} else {
									that.$message.error(res.msg)
								}
							})
						},
						onCancel() {
							that.$message.warning('你取消了操作')
						},
					})
				}
			},
			wechat(row) {
				var that = this
				this.$confirm({
					title: '是否确定解绑?',
					okText: '是',
					okType: 'danger',
					cancelText: '否',
					onOk() {
						update_wx({
							untie: true,
							userId: row.userId,
						}).then((res) => {
						// 	this.$nextTick(()=>{
                        //    $refs.table.refresh(true)
                        // })
							console.log('1111111111111111111111111111111111111')
							// this.hackReset  = false
							 // $nextTick 是在下次 DOM 更新完成后，在执行里面的函数，类似于回调
							that.$refs.table.refresh(true)
							that.$message.success(res.msg)
							// this.$forceUpdate()
							
						})
					// 	this.$nextTick(() => {
                    //     this.hackReset = true;
                    // })
					},
					
					onCancel() {
						that.$message.warning('你取消了操作')
					},
					
				})

			},
			onSelectChange(selectedRowKeys) {
				console.log('selectedRowKeys changed: ', selectedRowKeys)
				this.selectedRowKeys = selectedRowKeys
			},
			handleEdit(record) {
				this.$refs.modal.edit(record)
			},
			resetPwd(record) {
				this.$refs.pwdmodal.edit(record)
			},
			onChange(selectedRowKeys, selectedRows) {
				this.selectedRowKeys = selectedRowKeys
				this.selectedRows = selectedRows
			},
			handleOk() {
				this.$refs.table.refresh()
				console.log('handleSaveOk')
			},
			delByIds(ids) {
				delUser({
					ids: ids.join(','),
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success(`删除成功`)
						this.handleOk()
					} else {
						this.$message.error(res.msg)
					}
					// const difference = new Set(this.selectedRowKeys.filter(x => !new Set(ids).has(x)))
					// this.selectedRowKeys = Array.from(difference)
					this.selectedRowKeys = []
				})
			},
			onChangeStatus(row) {

				var _this = this
				this.$confirm({
					title: '确认执行该操作?',
					onOk() {
						if (row.status == 0) {
				_this.$router.push({
					path: '/system/UserList/quit?id=' + row.userId ,
				})
							
						} else {
							row.status = row.status === '0' ? '1' : '0'

						changUserStatus(pick(row, 'userId', 'status')).then((res) => {
							if (res.code === 200) {
								_this.$message.success('保存成功')
							} else {
								_this.$message.error(res.msg)
							}
						})

						}
				
						// _this.$router.push( '/system/UserList/quit?id=' + row.userId )
						
					},
					onCancel() {
						console.log('Cancel')
					},
					class: 'test',
				})

				// 发送状态到服务器
			},
			buildtree(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			// 下面是树相关方法
			handleSelect(selectedKeys, info) {
				this.queryParam = {
					deptId: selectedKeys[0],
				}
				this.$refs.table.refresh(true)
			},
		},
		watch: {
			loadData(){
				console.log('refresh');
				this.$refs.table.refresh()
			},
			/*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
		},
	}
</script>
<style scoped lang='less'>
	.left {
		width: 20%;
		height: 100%;
		overflow-y: scroll;
		padding-right: 10px;
		float: left;
	}

	.right {
		width: 80%;
		height: 100%;
		float: left;
	}
</style>
